/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Closing_BodyInputs */

const en_gc_home_closing_body = /** @type {(inputs: Gc_Home_Closing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try GridCraft online with a sample workbook. No installation or account required for the editor.`)
};

const zh_gc_home_closing_body = /** @type {(inputs: Gc_Home_Closing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用示例工作簿在线体验 GridCraft。编辑器无需安装，也无需注册。`)
};

/**
* | output |
* | --- |
* | "Try GridCraft online with a sample workbook. No installation or account required for the editor." |
*
* @param {Gc_Home_Closing_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_closing_body = /** @type {((inputs?: Gc_Home_Closing_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Closing_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_closing_body(inputs)
	return zh_gc_home_closing_body(inputs)
});
export { gc_home_closing_body as "gc.home.closing_body" }